import axios from 'axios';
import { DASHBOARD_GRAPHQL_URL } from '@appmaker/core/api/core';

export const BUILD_PROJECT_QUERY = `query {
    project {
        templateTag
        apps { id version token platform buildInProgress }
        meta { hideLegacyDownload }
    }
}`;

export async function getBuildProject(projectId) {
    const response = await axios.post(`${DASHBOARD_GRAPHQL_URL}/${projectId}/`, {
        query: BUILD_PROJECT_QUERY,
    }, { withCredentials: true, headers: { 'Content-Type': 'application/json' } });
    return response.data?.data?.project;
}
